<template>
    <v-container class="fill-height home_wrapper" fluid>
        <v-col cols="12" sm="12" md="6" lg="7" class="fill-height primary white--text">
            <v-row class="fill-height" align-content-md="center" >
                <v-col cols="12" class="text-right">
                    <img :src="`${require('../assets/Psychea_Logo_White.png')}`" class="d-flex ml-auto mb-6" style="width:65%" />
                    <div v-html="pageText"></div>
                </v-col>
            </v-row>
        </v-col>
        <v-col cols="12" sm="12" md="6" lg="5">
            <v-row class="fill-height" align-content-md="center">
                <v-col cols="12">
                    <LoginForm v-if="!userLoggedIn" />
                    <router-link v-else to="dashboard" tag="v-btn" class="primary">Перейти в кабинет</router-link>
                </v-col>
            </v-row>
        </v-col>
    </v-container>
</template>

<script>
import LoginForm from '../components/LoginForm.vue'
import StorageMixin from '../shared/StorageMixin'

export default {
    name:"Home",
    components: { LoginForm },
    mixins: [ StorageMixin ],
    data: () => ({
        userLoggedIn:false, headersSet:false, pageText:''
    }),
    created(){
        this.userLoggedIn = this.getToken() ? true : false
        this.$eventBus.$on('index_page_loaded', data => this.pageText = data.text)

        if(this.pageText == ''){
            this.getIndexData()
                .then(data => {
                    this.$eventBus.$emit('index_page_loaded', data)
                    this.data = data	
                })
        }
    },
    methods: {
		getIndexData(){
			return new Promise((res, rej) => {
			this.$api.get('/index/')
				.then(data =>  res(data.data))
				.catch(err => {
					console.log(err)
					rej(err)
				})
			})
		}
    },
}
</script>

<style lang="scss">
    .home_wrapper { padding:0!important; }
</style>